// import axios from 'axios';
import React, { useState, useEffect } from 'react';
import { Button, Col, Row, Select } from 'antd';
import {
  ApartmentOutlined,
  BulbOutlined,
  BuildOutlined,
  CoffeeOutlined,
  DownSquareOutlined,
  FormatPainterOutlined,
  FunnelPlotOutlined,
  LoadingOutlined,
  SearchOutlined,
  UpSquareOutlined,
} from '@ant-design/icons';
import {
  useNavigate,
  createSearchParams,
  URLSearchParamsInit,
} from 'react-router-dom';

import Layout from '../../layouts/User';
import styles from './index.module.scss';
import Slide from './slide';

export type Props = {};

interface Category {
  label: string;
  value: string;
  icon: JSX.Element;
}

const ServiceFilters: React.FC<Props> = (props) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [categories, setCategories] = useState<Category[]>([]);

  const getCategories = () => {
    setCategories([
      {
        label: 'งานปูน/พื้น/กระเบื้อง',
        value: 'floor',
        icon: (
          <img alt="electrical" src="/images/serviceJob/floor.svg" />
        ),
      },
      {
        label: 'งานเหล็ก/อลูมิเนียม/ไม้',
        value: 'aluminium',
        icon: (
          <img
            alt="water"
            src="/images/serviceJob/circular-saw.svg"
          />
        ),
      },
      {
        label: 'งานฝ้า/หลังคา',
        value: 'ceiling',
        icon: <img alt="floor" src="/images/serviceJob/house.svg" />,
      },
      {
        label: 'งานทาสี',
        value: 'paint',
        icon: (
          <img
            alt="aluminium"
            src="/images/serviceJob/paint-roller.svg"
          />
        ),
      },
      {
        label: 'ระบบไฟฟ้า',
        value: 'electrical',
        icon: (
          <img alt="ceiling" src="/images/serviceJob/lightbulb.svg" />
        ),
      },
      {
        label: 'ระบบประปา',
        value: 'water',
        icon: <img alt="paint" src="/images/serviceJob/shower.svg" />,
      },
      {
        label: 'ผู้รับเหมา',
        value: 'contractor',
        icon: (
          <img alt="contractor" src="/images/serviceJob/worker.svg" />
        ),
      },
      {
        label: 'ออกแบบ/สถาปนิก',
        value: 'architect',
        icon: (
          <img
            alt="architect"
            src="/images/serviceJob/architecture.svg"
          />
        ),
      },
    ]);
  };

  const applyFilters = (params: URLSearchParamsInit) => {
    navigate({
      pathname: 'address',
      search: `?${createSearchParams(params)}`,
    });
  };

  const CategoriesShortcuts = () => {
    return (
      <>
        <Row align="middle" gutter={[16, 48]}>
          {categories.map((cat) => (
            <Col xs={12} sm={6} key={cat.label}>
              <Row align="middle" justify="center">
                <Col>
                  <div
                    className={styles.category}
                    onClick={() =>
                      applyFilters({ category: cat.value })
                    }
                  >
                    {cat.icon}
                  </div>
                </Col>
                <Row>
                  <Col>
                    <div className={styles.catLabel}>{cat.label}</div>
                  </Col>
                </Row>
              </Row>
            </Col>
          ))}
        </Row>
      </>
    );
  };

  useEffect(() => {
    getCategories();
  }, []);

  const onClickTohistory = () => {
    navigate({
      pathname: '/profile/service-orders?status=CREATED',
      // search: `?${createSearchParams(params)}`,
    });
  };

  return (
    <>
      <Layout>
        <div className={styles.searchBox}>
          <Slide />
        </div>

        <div style={{ marginTop: '2rem' }}>
          <Row justify="space-between">
            <Col>
              <div
                className={[styles.header, styles.catHeader].join(
                  ' '
                )}
              >
                หมวดหมู่ช่าง
              </div>
            </Col>
            <Col>
              <Button
                type="primary"
                size="large"
                className={styles.btnHistory}
                onClick={onClickTohistory}
              >
                ประวัติการติดต่อช่าง
              </Button>
            </Col>
          </Row>

          <div style={{ textAlign: 'center' }}>
            {loading ? (
              <LoadingOutlined className={styles.loadingIcon} />
            ) : (
              <CategoriesShortcuts />
            )}
          </div>
        </div>
      </Layout>
    </>
  );
};

export default ServiceFilters;
